import React, { Component } from 'react'
import PropTypes from 'prop-types'
import SostaOnlineApiService from '../../../services/SostaOnlineApiService'
import { Axis, Chart, Cursor, Line, Series, Tooltip } from 'react-charts'
import moment from 'moment'
import { DateRangePicker, isInclusivelyBeforeDay } from 'react-dates'

moment.locale('it')

export default class BackofficeReports extends Component {
  static propTypes = {}

  constructor (props) {
    super(props)
    const now = moment()
    this.state = {
      loading: false,
      passReleasedLoading: false,
      passReleased: [],
      passReleasedStartDate: moment().subtract(1, 'months'),
      passReleasedEndDate: moment(),
      countersLoading: false,
      counters: [],
      countersStartDate: moment().subtract(1, 'months'),
      countersEndDate: moment(),
      countersTransactionLoading: false,
      countersTransaction: [],
      countersTransactionStartDate: moment().subtract(1, 'months'),
      countersTransactionEndDate: moment(),
    }

    this.onPassReleasedDateRangeChange = this.onPassReleasedDateRangeChange.bind(this)
    this.onCountersDateRangeChange = this.onCountersDateRangeChange.bind(this)
    this.onCountersTransactionsDateRangeChange = this.onCountersTransactionsDateRangeChange.bind(this)
  }

  async componentDidMount () {
    this.setState({loading: true})
    await this.fetchPassReleasedChart()
    await this.fetchGeneralCounters()
    await this.fetchTransactionCounters()
    this.setState({loading: false})
  }

  async fetchPassReleasedChart () {
    const {passReleasedStartDate, passReleasedEndDate} = this.state
    const result = await SostaOnlineApiService.fetchPassReleasedChart(
      passReleasedStartDate.format('YYYY-MM-DD'),
      passReleasedEndDate.format('YYYY-MM-DD')
    )
    this.setState({passReleased: result.data})
  }

  async fetchGeneralCounters () {
    const {countersStartDate, countersEndDate} = this.state
    const result = await SostaOnlineApiService.fetchGeneralCounters(
      countersStartDate.format('YYYY-MM-DD'),
      countersEndDate.format('YYYY-MM-DD')
    )
    this.setState({counters: result.data})
  }

  async fetchTransactionCounters () {
    const {countersTransactionStartDate, countersTransactionEndDate} = this.state
    const result = await SostaOnlineApiService.fetchOnlineTransactionsCounters(
      countersTransactionStartDate.format('YYYY-MM-DD'),
      countersTransactionEndDate.format('YYYY-MM-DD')
    )
    this.setState({countersTransaction: result.data})
  }

  onPassReleasedDateRangeChange ({ startDate, endDate }) {
    this.setState({
      passReleasedStartDate: startDate,
      passReleasedEndDate: endDate
    }, async () => {
      if (!this.state.passReleasedStartDate || !this.state.passReleasedEndDate) {
        return
      }

      this.setState({passReleasedLoading: true})
      await this.fetchPassReleasedChart()
      this.setState({passReleasedLoading: false})
    })
  }

  onCountersDateRangeChange ({ startDate, endDate }) {
    this.setState({
      countersStartDate: startDate,
      countersEndDate: endDate
    }, async () => {
      if (!this.state.countersStartDate || !this.state.countersEndDate) {
        return
      }

      this.setState({countersLoading: true})
      await this.fetchGeneralCounters()
      this.setState({countersLoading: false})
    })
  }

  onCountersTransactionsDateRangeChange ({ startDate, endDate }) {
    this.setState({
      countersTransactionStartDate: startDate,
      countersTransactionEndDate: endDate
    }, async () => {
      if (!this.state.countersTransactionStartDate || !this.state.countersTransactionEndDate) {
        return
      }

      this.setState({countersTransactionLoading: true})
      await this.fetchTransactionCounters()
      this.setState({countersTransactionLoading: false})
    })
  }

  render () {
    const {
      passReleased,
      loading,
      passReleasedLoading,
      passReleasedStartDate,
      passReleasedEndDate,
      passReleasedFocusedDate,
      counters,
      countersLoading,
      countersStartDate,
      countersEndDate,
      countersFocusedDate,
      countersTransaction,
      countersTransactionLoading,
      countersTransactionStartDate,
      countersTransactionEndDate,
      countersTransactionFocusedDate
    } = this.state

    if (loading) {
      return (
        <div>Caricamento in corso...</div>
      )
    }

    return (
      <div>
        <div className="titolo-categoria">
          <legend className="text-left">Contrassegni rilasciati al giorno</legend>
        </div>
        <div>
          <DateRangePicker
            isOutsideRange={day => !isInclusivelyBeforeDay(day, moment())}
            startDate={passReleasedStartDate} // momentPropTypes.momentObj or null,
            startDateId="your_unique_start_date_id" // PropTypes.string.isRequired,
            endDate={passReleasedEndDate} // momentPropTypes.momentObj or null,
            endDateId="your_unique_end_date_id" // PropTypes.string.isRequired,
            onDatesChange={this.onPassReleasedDateRangeChange} // PropTypes.func.isRequired,
            focusedInput={passReleasedFocusedDate} // PropTypes.oneOf([START_DATE, END_DATE]) or null,
            onFocusChange={focusedInput => this.setState({ passReleasedFocusedDate: focusedInput })}
          />
        </div>
        {passReleasedLoading ? (
          <div style={{height: '400px', backgroundColor: '#ffffff'}} />
        ) : (
          <div style={{height: '400px', padding: '10px 20px 10px 0px'}}>
            <Chart
              data={passReleased.firstGraph}
              getSeries={data => data}
              getDatums={serie => serie.data}
              getPrimary={(datum) => { return moment(datum.date) }}
              getSecondary={datum => datum.count}
              getLabel={series => series.label}
            >
              <Axis hardMin={passReleasedStartDate} hardMax={passReleasedEndDate} primary type="time" />
              <Axis min={0} type="linear" />
              <Series type={Line} />
              <Cursor primary />
              <Cursor />
              <Tooltip />
            </Chart>
          </div>
        )}
        <div className="titolo-categoria">
          <legend className="text-left">Contrassegni rinnovati al giorno</legend>
        </div>
        {passReleasedLoading ? (
          <div style={{height: '400px', backgroundColor: '#ffffff'}} />
        ) : (
          <div style={{height: '400px', padding: '10px 20px 10px 0px'}}>
            <Chart
              data={passReleased.secondGraph}
              getSeries={data => data}
              getDatums={serie => serie.data}
              getPrimary={(datum) => { return moment(datum.date) }}
              getSecondary={datum => datum.count}
              getLabel={series => series.label}
            >
              <Axis hardMin={passReleasedStartDate} hardMax={passReleasedEndDate} primary type="time" />
              <Axis min={0} type="linear" />
              <Series type={Line} />
              <Cursor primary />
              <Cursor />
              <Tooltip />
            </Chart>
          </div>
        )}

        <div className="titolo-categoria">
          <legend className="text-left">Contatori</legend>
        </div>
        <div>
          <DateRangePicker
            isOutsideRange={day => !isInclusivelyBeforeDay(day, moment())}
            startDate={countersStartDate}
            startDateId="counters_start_date"
            endDate={countersEndDate}
            endDateId="counters_end_date"
            onDatesChange={this.onCountersDateRangeChange}
            focusedInput={countersFocusedDate}
            onFocusChange={focusedInput => this.setState({ countersFocusedDate: focusedInput })}
          />
        </div>

        <div className="row" style={{marginTop: '20px'}}>

          <div className="col-md-3 text-center">
            <div className="thumbnail">
              <div className="caption">
                <div className="text-primary" style={{fontSize: '35px'}}>{counters.activeMarks}</div>
                <span>Contrassegni Attivi</span>
              </div>
            </div>
          </div>

          <div className="col-md-3 text-center">
            <div className="thumbnail">
              <div className="caption">
                <div className="text-primary" style={{fontSize: '35px'}}>{counters.activeParkTickets}</div>
                <span>Abbonamenti Attivi</span>
              </div>
            </div>
          </div>

          <div className="col-md-2 text-center">
            <div className="thumbnail">
              <div className="caption">
                <div className="text-success" style={{fontSize: '35px'}}>{counters.onlineRegisteredUsers}</div>
                <span>Utenti Registrati Online</span>
              </div>
            </div>
          </div>

          <div className="col-md-2 text-center">
            <div className="thumbnail">
              <div className="caption">
                <div style={{fontSize: '35px'}}>{counters.offlineCreatedUsers}</div>
                <span>Utenti Creati Offline</span>
              </div>
            </div>
          </div>
        </div>

        <div className="row" style={{marginTop: '20px'}}>

          <div className="col-md-3 text-center">
            <div className="thumbnail">
              <div className="caption">
                <div className="text-info" style={{fontSize: '35px'}}>{counters.parkTicketsCreated}</div>
                <span>Totale Abbonamenti</span>
              </div>
            </div>
          </div>

          <div className="col-md-3 text-center">
            <div className="thumbnail">
              <div className="caption">
                <div className="text-success" style={{fontSize: '35px'}}>{counters.parkTicketsSelledOnline}</div>
                <span>Abb. Venduti Online</span>
              </div>
            </div>
          </div>
        </div>

        <div className="row" style={{marginTop: '20px'}}>
          <div className="col-md-4">
            <ul className="list-group">
              <li class="list-group-item list-group-item-info">Totale Contrassegni per tipologia:</li>
              {(!countersLoading && counters.markTypes) && counters.markTypes.map((item, index) => (
                <li key={'mark-type-counter-' + index} className="list-group-item">
                  <span className="badge" style={{fontSize: '20px'}}>{item.markCounts}</span>
                  {item.name.toLowerCase()}
                </li>
              ))}
            </ul>
          </div>

          <div className="col-md-6">
            <div className="row">
              <div className="col-md-12">
                <div className="text-center">
                  <div className="thumbnail">
                    <div className="caption">
                      <div style={{fontSize: '35px'}} className="text-info">{counters.marksCreated}</div>
                      <span>Totale Contrassegni</span>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-md-6">
                <div className="text-center">
                  <div className="thumbnail">
                    <div className="caption">
                      <div className="text-success" style={{fontSize: '35px'}}>{counters.marksSoldOnline}</div>
                      <span>Contr. Rilasciati Online</span>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-md-6">
                <div className="text-center">
                  <div className="thumbnail">
                    <div className="caption">
                      <div style={{fontSize: '35px'}}>
                        {counters.marksCreated - counters.marksSoldOnline}
                      </div>
                      <span>Contr. Rilasciati Offline</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>


        <div className="titolo-categoria">
          <legend className="text-left">Contatori Operazioni Online</legend>
        </div>
        <div>
          <DateRangePicker
            isOutsideRange={day => !isInclusivelyBeforeDay(day, moment())}
            startDate={countersTransactionStartDate}
            startDateId="counters_transaction_start_date"
            endDate={countersTransactionEndDate}
            endDateId="counters_transaction_end_date"
            onDatesChange={this.onCountersTransactionsDateRangeChange}
            focusedInput={countersTransactionFocusedDate}
            onFocusChange={focusedInput => this.setState({ countersTransactionFocusedDate: focusedInput })}
          />
        </div>

        <div className="row" style={{marginTop: '20px'}}>

          <div className="col-md-4 text-center">
            <div className="thumbnail">
              <div className="caption">
                <div className="text-info" style={{fontSize: '35px'}}>
                  {countersTransaction.totalOrdersOnline}
                </div>
                <span>Totale Transazioni</span>
              </div>
            </div>
          </div>

          <div className="col-md-3 text-center">
            <div className="thumbnail">
              <div className="caption">
                <div className="text-success" style={{fontSize: '35px'}}>
                  {countersTransaction.totalOrdersOnlineCompleted}
                </div>
                <span>Trans. Completate</span>
              </div>
            </div>
          </div>

          <div className="col-md-3 text-center">
            <div className="thumbnail">
              <div className="caption">
                <div className="text-danger" style={{fontSize: '35px'}}>
                  {countersTransaction.totalOrdersOnlineRejected}
                </div>
                <span>Trans. Rifiutate</span>
              </div>
            </div>
          </div>
        </div>

        <div className="row" style={{marginTop: '20px'}}>
          <div className="col-md-4 text-center">
            <div className="thumbnail">
              <div className="caption">
                <div className="text-info" style={{fontSize: '35px'}}>
                  {countersTransaction.totalOperations}
                </div>
                <span>Totale Operazioni</span>
              </div>
            </div>
          </div>

          <div className="col-md-3 text-center">
            <div className="thumbnail">
              <div className="caption">
                <div className="text-success" style={{fontSize: '35px'}}>
                  {countersTransaction.totalOnlineOperations}
                </div>
                <span>Operazioni Online</span>
              </div>
            </div>
          </div>

          <div className="col-md-3 text-center">
            <div className="thumbnail">
              <div className="caption text-info">
                <div style={{fontSize: '35px'}}>
                  {countersTransaction.totalOperations - countersTransaction.totalOnlineOperations}
                </div>
                <span>Operazioni Offline</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/Backoffice/Reports/BackofficeReports.js